export default {"src":"/_next/static/media/account-settings.c65c847a.svg","height":21,"width":21};